import { AppNames } from 'config/appConfig'
import { AppTypes } from 'types/AppTypes'

export default {
  EMAIL_LOG: {
    path: 'email-log',
    legacyPath: '',
    appAccess: [AppNames.admin],
    authorization: {
      appTypeAccess: [AppTypes.admin, AppTypes.pdDomainId, AppTypes.helpdesk, AppTypes.accountHelpdesk]
    },
    metadata: {
      sideMenuId: 'EMAIL_LOG'
    }
  },
  EMAIL_POLICIES: {
    path: 'email-policies',
    legacyPath: '',
    appAccess: [AppNames.admin],
    authorization: {
      appTypeAccess: [AppTypes.admin, AppTypes.pdDomainId, AppTypes.helpdesk, AppTypes.accountHelpdesk]
    },
    metadata: {
      sideMenuId: 'EMAIL_POLICIES'
    }
  }
}
